import * as React from 'react';

export interface IButtonProps {
  name?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  children?: React.ReactNode; 
}

export default function Button(props: IButtonProps) {
  return (
    <div className="flex justify-center items-center">
      <button
        className={
          props.className
            ? props.className
            : `text-[12px] font-bold text-white bg-gray-800 text-center p-2 w-[100px] rounded-md cursor-pointer`
        }
        onClick={props.onClick}
        type={props.type || 'button'}
        disabled={props.disabled}
      >
        {props.loading ? 'Loading...' : props.children || props.name}
      </button>
    </div>
  );
}
